import {
    SET_SUPER_REGION,
} from "./SuperRegionType";

const reducer = (state = [], action: any) => {
    switch (action.type) {
        case SET_SUPER_REGION:
            return {
                ...state,
                superRegionDropDownList: action.superRegionDropDownList,
            };
        default:
            return state;
    }
};

export default reducer;